import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UserService} from '../../services/user.service';
import {findIndex} from 'lodash';
import RoleEnum from "../../models/enums/roleEnum";

@Component({
    selector: 'app-search-users',
    templateUrl: './search-users.component.html',
    styleUrls: ['./search-users.component.scss']
})
export class SearchUsersComponent implements OnInit, OnDestroy, OnChanges {

    @Input() multiple = false;
    @Input() disabled = false;
    @Input() placeholder: string;
    @Input() user: any;
    @Input() roles: string[];
    @Input() selectedIds: number[];

    @Output() onSelectUser = new EventEmitter<any>();

    currentCompany: any;
    users: any[] = [];
    loading = false;

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        if (this.selectedIds) {
            this.loadListUsers(this.roles ? this.roles : undefined);
        }
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onChange(event) {
        this.onSelectUser.emit(event);
        this.user = event;
    }

    loadListUsers(roleStr: string[]) {

        if (!this.users || this.users.length === 0) {
            this.loading = true;
            this.userService.findAllBasic(roleStr)
                .subscribe(res => {
                    this.loading = false;
                    this.users = res;
                    if (this.selectedIds && !this.multiple) {
                        const i = findIndex(this.users, (u) => {
                            return this.selectedIds.includes(u.id);
                        });
                        this.user = this.users[i];
                    }
                }, err => {
                    this.loading = false;
                    console.log(err);
                });
        }
    }

    customSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        const fullName = item.lastName + ' ' + item.firstName;
        return (item.firstName && item.firstName.toLowerCase().indexOf(term) > -1) ||
            (item.lastName && item.lastName.toLowerCase().indexOf(term) > -1) ||
            (fullName && fullName.toLowerCase().indexOf(term) > -1);
    }
}
